import { render, staticRenderFns } from "./V3Migration.vue?vue&type=template&id=5c1f505c&scoped=true"
import script from "./V3Migration.vue?vue&type=script&lang=js"
export * from "./V3Migration.vue?vue&type=script&lang=js"
import style0 from "./V3Migration.vue?vue&type=style&index=0&id=5c1f505c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1f505c",
  null
  
)

export default component.exports